import { useState, useMemo } from 'react';

// export function useTableSelection(data = []) {
export function useTableSelection(rowSel) {
  const [rowSelection, setRowSelection] = useState(rowSel || {});

  // const selectedItems = useMemo(() => {
  // }, [rowSelection, data]);

  return {
    rowSelection,
    setRowSelection,
    // selectedItems,
  };
}